import { useEffect } from 'react'
import { clearAccessTokenReducer } from '../hooks/redux/slice/access-token';
import { clearLoggedUserReducer } from '../hooks/redux/slice/logged-user';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from './url-constant';
import { useDispatch } from 'react-redux';

const AdminAppLogout = ({ children }) => {
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress",
    ];
    let timer;

    // this function sets the timer that logs out the user after 10 secs
    const handleLogoutTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            // logs out user
            logoutAction();
        }, 3600000); // 3600000 = 60secs. You can change the time.
    };

    const resetTimer = () => {
        if (timer) clearTimeout(timer);
    };

    // when component mounts, it adds an event listeners to the window
    // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after 10 secs of inactivity resets.
    // However, if none of the event is triggered within 10 secs, that is app is inactive, the app automatically logs out.
    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleLogoutTimer();
            });
        });
    }, []);


    // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
    const logoutAction = () => {
        dispatch(clearAccessTokenReducer());
        dispatch(clearLoggedUserReducer());
        localStorage.removeItem("RoleValue")
        localStorage.removeItem("DimesionMenegmentModalId")
        localStorage.removeItem("sub-DimesionMenegmentModalId");
        localStorage.removeItem("sub-DimesionMenegmentDimesionId");
        localStorage.removeItem("criteriaMenegmentModalId");
        localStorage.removeItem("criteriaMenegmentDimesionId");
        localStorage.removeItem("criteriaMenegmentSubDimesionId");
        localStorage.removeItem("ViewAssesmentCompanyId")
        localStorage.removeItem("OnsiteCompanyId")
        navigation(ROUTES.ADMINLOGINPAGE);

    };
    return children;
}

export default AdminAppLogout
